export const blockScroll = (trigger: boolean) => {
  const body = document.querySelector('body');
  if (!body) return;

  body.style.overflow = trigger ? 'hidden' : 'initial';
};
